import styled from '@emotion/styled';
import alertIcon from '../assets/images/icon-alert-solid.svg';

export const FieldErrorAlert = styled.div((props) => {
  let style = {
    display: 'block',
    flexShrink: '0',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundImage: 'url(' + alertIcon + ')',
    width: '14px',
    height: '14px',
    marginTop: '12px'
  };
  // these are pushing it closer to the input, given that
  //  this widget is living in a flex container.
  if (props.isRtl) {
    style.marginLeft = '5px';
  } else {
    style.marginRight = '5px';
  }
  return style;
});



// WEBPACK FOOTER //
// ./src/styles/FieldErrorAlert.js